import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=2d082268&"
import script from "./AddAdmin.vue?vue&type=script&lang=js&"
export * from "./AddAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d082268')) {
      api.createRecord('2d082268', component.options)
    } else {
      api.reload('2d082268', component.options)
    }
    module.hot.accept("./AddAdmin.vue?vue&type=template&id=2d082268&", function () {
      api.rerender('2d082268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AddAdmin.vue"
export default component.exports